module.exports = __webpack_public_path__ + "img/alfabank.178b58b.svg";